// Form Drawer functionality
document.addEventListener('DOMContentLoaded', function() {
    // Form Drawer class
    class FormDrawer {
        constructor(element) {
            this.element = element;
            this.activeElement = null;
            this.init();
        }

        init() {
            this.element.addEventListener('click', this.handleOutsideClick.bind(this));
        }

        open(opener) {
            if (opener) this.setActiveElement(opener);
            this.element.classList.add("is-visible");
            document.querySelector('body').style.overflow = 'hidden';
            this.element.addEventListener("transitionend", () => { this.focusOnDrawer(); }, { once: true });

            setTimeout(() => {
                document.addEventListener("click", this.handleOutsideClick.bind(this));
            }, 100);
        }

        close() {
            this.element.classList.remove("is-visible");
            document.querySelector('body').style.overflow = 'auto';
            if (this.activeElement) {
                this.activeElement.focus();
            }

            document.removeEventListener("click", this.handleOutsideClick.bind(this));
            
            // Re-setup trigger buttons after closing to ensure they work
            setTimeout(() => {
                setupTriggerButtons();
            }, 100);
        }

        handleOutsideClick(event) {
            const drawerInner = this.element.querySelector(".form-drawer__inner");
            if (drawerInner && !drawerInner.contains(event.target)) {
                this.close();
            }
        }

        setActiveElement(element) {
            this.activeElement = element;
        }

        focusOnDrawer() {
            const containerToTrapFocusOn = this.element.firstElementChild;
            const focusElement = this.element.querySelector("[data-drawer-close]");
            if (window.trapFocus) {
                trapFocus(containerToTrapFocusOn, focusElement);
            }
        }
    }

    // Initialize form drawers
    function initializeFormDrawers() {
        const drawerElements = document.querySelectorAll('[data-form-drawer]');
        drawerElements.forEach(element => {
            if (!element.formDrawer) {
                element.formDrawer = new FormDrawer(element);
            }
        });
    }

    // Trigger button functionality
    function setupTriggerButtons() {
        const triggerButtons = document.querySelectorAll('[data-drawer-trigger]');
        triggerButtons.forEach(button => {
            // Remove existing event listeners to prevent duplicates
            button.removeEventListener('click', handleTriggerClick);
            button.addEventListener('click', handleTriggerClick);
        });
    }

    function handleTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const sectionId = this.getAttribute('data-drawer-trigger');
        
        // The sectionId is actually the full drawer ID, so use it directly
        let drawerElement = document.querySelector(`#${sectionId}`);
        
        if (drawerElement && drawerElement.formDrawer) {
            try {
                drawerElement.formDrawer.open(this);
                // Focus on the first input field
                const firstInput = drawerElement.querySelector('input, textarea, select');
                if (firstInput) {
                    setTimeout(() => firstInput.focus(), 100);
                }
            } catch (error) {
                console.error('Error calling drawer.open():', error);
            }
        }
    }

    // Initialize drawers on DOM ready
    initializeFormDrawers();

    // Setup trigger buttons on DOM ready
    setupTriggerButtons();

    // Also setup trigger buttons when Shopify sections are loaded
    document.addEventListener('shopify:section:load', function() {
        initializeFormDrawers();
        setupTriggerButtons();
    });

    // Handle drawer close button
    const closeButtons = document.querySelectorAll('.form-drawer__close');
    closeButtons.forEach(button => {
        button.addEventListener('click', function() {
            const drawerElement = this.closest('[data-form-drawer]');
            if (drawerElement && drawerElement.formDrawer) {
                drawerElement.formDrawer.close();
            }
        });
    });
}); 